import { browserSupportsWebAuthn } from "@simplewebauthn/browser";
import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { AppConfig } from "../../../AppConfig";
import { PageRoutes } from "../../../constants/routes";
import { LocalStorageManager } from "../../../core/storage/LocalStorageManager";
import { authActions } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";
import { AppDispatch } from "../../../store";

export const useEmailRegistrationComplete = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { navigateToPage } = useNavigation();
  const { state } = useLocation();
  const { accessToken, isFidoRegistered } = state ?? {};

  useEffect(() => {
    if (!accessToken) return navigateToPage(PageRoutes.LOGIN);
  }, [accessToken, navigateToPage]);

  const handleEmailRegistrationComplete = useCallback(() => {
    if (isFidoRegistered || !browserSupportsWebAuthn()) {
      dispatch(authActions.setIsLoggedIn(true));

      LocalStorageManager.Instance.saveObject(
        AppConfig.Instance.LocalStorageKey["accessToken"],
        accessToken,
      );

      // HOMEに遷移を追加
      navigateToPage(PageRoutes.HOME);
    } else navigateToPage(PageRoutes.EASY_LOGIN, false, { accessToken });
  }, [accessToken, dispatch, isFidoRegistered, navigateToPage]);

  return { handleEmailRegistrationComplete };
};
